<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs10 class="text-xs-center">
        <v-alert v-model="alert" type="warning" dismissible :timeout="timeout" v-if="loadedNotice">
          {{ loadedNotice.noticeName }}
        </v-alert>
        <img class="logo" src="static/img/victorium_logo.png" />
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="mt-4">
      <v-flex xs12 sm8 md6>
        <v-card class="homeInfo" v-for="item in items" v-bind:key="item.title"  :to="item.link">
          <v-list class="listItems pa-0">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <v-icon left>{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn flat light>
                    <right-icon></right-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
          </v-list>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
    </v-layout>	
    <v-layout row wrap justify-center class="mt-4">
      <v-flex xs12 class="text-xs-center">
        <v-btn flat class="alt pa-2" :href="'tel:210-639-2242'">
          <phoneIcon left class="icon" />
          Call
        </v-btn>
        <v-btn flat class="alt pa-2" :href="'mailto:test@test.com?subject=Get Help&body='">
          <emailIcon left class="icon" />
          Email
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="mt-4">
      <v-flex xs12 class="text-xs-center">
        <v-btn flat class="alt pa-2 whyBtn">
          Why Research? (PDF)
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 md6 class="text-xs-center">
        <v-progress-circular 
        indeterminate 
        color="primary"
        :width="7"
        :size="70"
        v-if="loading"></v-progress-circular>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        alert: true,
        timeout: 6000,
        items: [
          // { active: true, title: 'Trials By Location', icon: 'location_on', link: '/Trials/Locations' },
          { active: true, title: 'Trials By San Antonio', icon: 'location_on', link: '/Trials/locations/-L77m6Y3Rk0F10RtZCFD' },
          { active: true, title: 'Trials By Houston', icon: 'location_on', link: '/Trials/locations/-L9cIQfsVcCvP_h_gH6b' },
          { active: false, title: 'Trials By Indication', icon: 'bookmark_border', link: '/Trials/Indications' },
          { title: 'Trials By Investigator', icon: 'person_pin', link: '/Trials/Investigators' },
          { title: 'Trials By Coordinator', icon: 'person_pin', link: '/Trials/Coordinators' }
        ]
      }
    },
    computed: {
      trials () {
        return this.$store.getters.featuredTrials
      },
      loading () {
        return this.$store.getters.loading
      },
      checkLocations () {
        if (this.$route.path === '/') {
          return true
        }
        return
      },
      loadedNotice () {
        if (typeof this.$store.getters.loadedNotice !== 'undefined') {
          return this.$store.getters.loadedNotice
        }
        return
      }
    },
    methods: {
      onLoadTrial (id) {
        this.$router.push('/trials/' + id)
      }
    }
  }
</script>

<style scoped>
  .logo{
    max-width: 180px;
  }
  .title{
    color: white;
    position: absolute;
    bottom: 50px;
    background: rgba(0, 0, 0, 0.5);
    padding: 20px;
  }
  span{
    clear: both;
    display: block;
    color: red;
  }
  .homeInfo{
    box-shadow: none;
  }
  .whyBtn{
    min-width: 280px;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?4f6fd97c